import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import cronstrue from 'cronstrue';
import 'cronstrue/locales/it';

@Pipe({
  name: 'cronToNaturalLanguage',
  pure: true,
})
export class CronToNaturalLanguagePipe implements PipeTransform {
  private translateService = inject(TranslateService);

  transform(value: string | null | undefined): string | null {
    if (!value?.trim()) return null;

    const locale = this.translateService.currentLang ?? 'en';

    try {
      return cronstrue.toString(value, { locale, throwExceptionOnParseError: true });
    } catch {
      return value;
    }
  }
}
